import { ApiProperty } from "@nestjs/swagger";
import { LoadingSheetDto } from "./dto/loading-sheet-dto";



export class LoadingSheetReqDto {

    @ApiProperty()
    containerId: number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty({type:[LoadingSheetDto]})
    loadingSheetReq: LoadingSheetDto[];



}